import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductCollectionVolume extends Component {
  sectionElement = null;

  connectedCallback() {
    super.connectedCallback();

    this.sectionElement = this.closest('.shopify-section, dialog');

    this.sectionElement?.addEventListener(
      StandardEvents.productSelect,
      this.handleProductSelect
    );
  }

  disconnectedCallback() {
    this.sectionElement?.removeEventListener(
      StandardEvents.productSelect,
      this.handleProductSelect
    );

    super.disconnectedCallback();
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    if (event.target.closest('product-card')) {
      return;
    }

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) {
          return;
        }

        if (
          !detail.newProduct &&
          detail.productId &&
          String(detail.productId) !== this.dataset.productId
        ) {
          return;
        }

        const blockId = this.dataset.blockId;

        if (!blockId) {
          return;
        }

        const updatedElement = detail.html.querySelector(
          `product-collection-volume[data-block-id="${blockId}"]`
        );

        if (!updatedElement) {
          return;
        }

        this.replaceWith(updatedElement.cloneNode(true));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(
            '[product-collection-volume] Variant update failed:',
            error
          );
        }
      });
  };
}

if (!customElements.get('product-collection-volume')) {
  customElements.define(
    'product-collection-volume',
    ProductCollectionVolume
  );
}